var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-text-field',_vm._b({ref:"field",attrs:{"prefix":_vm.prefix,"value":_vm.formattedValue,"error-messages":_vm.errorMessages,"rules":_vm.validationRules},on:{"change":function($event){_vm.formattedValue = $event}}},'v-text-field',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }